import { render, staticRenderFns } from "./ListArboSnapshot.vue?vue&type=template&id=0f6b3f76&"
import script from "./ListArboSnapshot.vue?vue&type=script&lang=js&"
export * from "./ListArboSnapshot.vue?vue&type=script&lang=js&"
import style0 from "./ListArboSnapshot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports